/* Mobile menu accordion
   Converts #MenuDrawer drill-down panels into inline accordion. */

(function () {
  var DRAWER_ID = 'MenuDrawer';
  var CLASS_NAME = 'ig-mm-accordion';
  var INIT_ATTR = 'data-ig-mm-accordion';

  function getDrawer() {
    return document.getElementById(DRAWER_ID);
  }

  function closeDetails(details) {
    if (!details) return;
    details.removeAttribute('open');
    details.classList.remove('active', 'open');
    var summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    details.querySelectorAll('details[open], details.active').forEach(function (nested) {
      nested.removeAttribute('open');
      nested.classList.remove('active', 'open');
      var nestedSummary = nested.querySelector(':scope > summary');
      if (nestedSummary) nestedSummary.setAttribute('aria-expanded', 'false');
    });
  }

  function openDetails(details) {
    details.setAttribute('open', '');
    details.classList.add('active');
    details.classList.remove('open');
    var summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');

    // Keep parent lists from entering slide-panel mode
    var parent = details.closest('[data-parent]');
    if (parent) parent.classList.remove('active');

    // Keep opened section reachable inside the scrollable nav
    var drawer = getDrawer();
    var nav = drawer && drawer.querySelector('.menu-drawer__content > nav');
    if (nav && summary) {
      setTimeout(function () {
        var top = summary.offsetTop - 12;
        if (typeof nav.scrollTo === 'function') {
          nav.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
        } else {
          nav.scrollTop = Math.max(top, 0);
        }
      }, 50);
    }
  }

  function closeSiblingDetails(details) {
    var li = details.parentElement;
    if (!li) return;
    var list = li.parentElement;
    if (!list) return;

    Array.prototype.forEach.call(list.children, function (siblingLi) {
      if (siblingLi === li) return;
      var siblingDetails = siblingLi.querySelector(':scope > details');
      if (siblingDetails) closeDetails(siblingDetails);
    });
  }

  function onSummaryClick(event) {
    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains(CLASS_NAME)) return;

    var summary = event.target.closest('summary.menu-drawer__item-link');
    if (!summary || !drawer.contains(summary)) return;

    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var willOpen = !details.hasAttribute('open');
    closeSiblingDetails(details);

    if (willOpen) {
      openDetails(details);
    } else {
      closeDetails(details);
    }
  }

  function resetAll(drawer) {
    drawer.querySelectorAll('details[is="menu-drawer-details"]').forEach(closeDetails);
    drawer.querySelectorAll('.active').forEach(function (el) {
      if (el.matches('details, .menu-drawer__menus, .menu-drawer__submenu, .v-scrollable')) {
        el.classList.remove('active');
      }
    });
  }

  function getPromoTitle(item, anchor) {
    var label = anchor && anchor.getAttribute('aria-label');
    if (label && label.trim()) return label.trim();

    var heading = item.querySelector('.card-media__heading, .reversed-link, .h5, h2, h3, h4');
    if (heading && heading.textContent) return heading.textContent.replace(/\s+/g, ' ').trim();

    return '';
  }

  /* Collections (and similar) only have image promo cards — convert to name links */
  function convertPromoCardsToNameLinks(drawer) {
    drawer.querySelectorAll('.menu-drawer__promotions, .mega-menu__promotions').forEach(function (promo) {
      if (promo.getAttribute('data-ig-converted') === '1') return;

      // Keep product carousels hidden
      if (promo.querySelector('.promotion-item--product')) {
        promo.setAttribute('data-ig-converted', '1');
        promo.classList.add('ig-mm-promo-hidden');
        return;
      }

      var items = promo.querySelectorAll('.promotion-item');
      if (!items.length) {
        promo.setAttribute('data-ig-converted', '1');
        promo.classList.add('ig-mm-promo-hidden');
        return;
      }

      var list = document.createElement('ul');
      list.className = 'ig-mm-promo-names';
      list.setAttribute('role', 'list');

      var added = 0;
      Array.prototype.forEach.call(items, function (item) {
        var anchor = item.querySelector('a[href]');
        if (!anchor) return;

        var title = getPromoTitle(item, anchor);
        if (!title) return;

        var li = document.createElement('li');
        li.className = 'menu-drawer__item ig-mm-promo-name-item';

        var link = document.createElement('a');
        link.href = anchor.href;
        link.className = 'menu-drawer__item-link flex items-center justify-between ig-mm-promo-name-link';
        link.textContent = title;

        li.appendChild(link);
        list.appendChild(li);
        added += 1;
      });

      promo.setAttribute('data-ig-converted', '1');
      promo.classList.add('ig-mm-promo-hidden');

      if (added > 0 && promo.parentNode) {
        promo.parentNode.insertBefore(list, promo);
      }
    });
  }

  function bind(drawer) {
    if (drawer.getAttribute(INIT_ATTR) === '1') return;
    drawer.setAttribute(INIT_ATTR, '1');
    drawer.classList.add(CLASS_NAME);
    convertPromoCardsToNameLinks(drawer);

    // Capture phase so theme MenuDrawerDetails handler never runs
    drawer.addEventListener('click', onSummaryClick, true);

    // When drawer closes, collapse accordion state
    drawer.addEventListener(
      'click',
      function (event) {
        var closeBtn = event.target.closest('[aria-controls="MenuDrawer"]');
        if (!closeBtn) return;
        setTimeout(function () {
          resetAll(drawer);
        }, 450);
      },
      false
    );
  }

  function init() {
    var drawer = getDrawer();
    if (!drawer) return false;
    bind(drawer);
    return true;
  }

  if (!init()) {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (init() || tries > 40) clearInterval(timer);
    }, 250);
  }

  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
